import { HStack, Text } from "@chakra-ui/react";

import { TableProperty } from "@shared/components/Table";
import { EvalAverageScores, EvalRunModel } from "@shared/models";
import { getUSFormatedDateTime } from "@shared/utils";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

import { TOP_EVAL_CRITERIA } from "./evaluation";
import { DeleteEvalRun, EvalRunStatusBadge } from "../components";

const getScoreColor = (score: number) => {
  if (score >= 4) return "score.highText";
  if (score >= 3) return "score.midText";

  return "score.lowText";
};

const EvalRunScores = ({ scores }: { scores: EvalAverageScores }) => (
  <HStack gap="12px">
    {TOP_EVAL_CRITERIA.map((criterion) => {
      const score = scores[criterion];

      if (score === undefined) return null;

      return (
        <Text key={criterion} fontSize="12px" whiteSpace="nowrap" color="brand.grey">
          {criterion.slice(0, 3).toUpperCase()}{" "}
          <Text as="span" color={getScoreColor(score)} fontWeight={FONT_WEIGHT.HEAVY}>
            {score.toFixed(1)}
          </Text>
        </Text>
      );
    })}
  </HStack>
);

export const evalRunTableProperties: TableProperty<EvalRunModel>[] = [
  {
    title: "RUN ID",
    key: "uuid",
    get: (item) => (
      <Text fontSize="12px" fontFamily="mono" fontWeight={FONT_WEIGHT.HEAVY}>
        {item.uuid.slice(0, 8)}
      </Text>
    ),
  },
  {
    title: "CASES",
    key: "total_cases",
    get: (item) => item.total_cases,
  },
  {
    title: "STATUS",
    key: "status",
    get: (item) => <EvalRunStatusBadge status={item.status} />,
  },
  {
    title: "SCORES",
    key: "average_scores",
    get: (item) => <EvalRunScores scores={item.average_scores} />,
  },
  {
    title: "DATE",
    key: "created_at",
    get: (item) => getUSFormatedDateTime(item.created_at),
  },
  {
    title: "",
    key: "id",
    get: (item) => <DeleteEvalRun item={item} onClick={(e) => e.stopPropagation()} />,
  },
];
